import {RightArrow} from './common/RightArrow';
import {useTranslation} from "react-i18next";
import {NavLink} from "react-router-dom";

const ProductCard = ({img, title, content, link}) => {
    return (
        <div data-aos="fade-up" className="product-card max-w-lg flex flex-col">
            <img src={img} alt={title} className="grow-0 aspect-[9/5] max-md:aspect-2 object-cover rounded-t-[30px]"/>
            <div className="px-4 flex flex-col items-start mt-8 max-md:mt-4">
                <h2>{title}</h2>
                <p className="mt-2 lg:mt-4">{content}</p>
            </div>
            <NavLink to={`product/${link}`}><SeeProduct/></NavLink>
        </div>
    );
}

export default ProductCard;

function SeeProduct() {
    const { t } = useTranslation();
    return (
        <div className="mr-4 flex justify-end place-items-end flex-grow">
            <div className="flex rounded px-2 py-1 my-6 max-md:mt-2 bg-secondary">
                <div className="text-sm mr-2 font-bold text-primary">{t('general_see_product')}</div>
                <RightArrow color="text-primary"/>
            </div>
        </div>
    )
}